var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFillet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 135.47 135.47",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.682,
    y: 43.409,
    width: 37.312,
    height: 6.8883,
    fill: "#a7a7a7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -118.9,
    y: 86.153,
    width: 37.312,
    height: 6.8883,
    fill: "#a7a7a7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0f79fd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63.726 46.578h25.572v31.254",
    strokeWidth: 6.3502
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3.9966
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49.36 24.916 27.398-0.20295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.088 14.16 11.67 10.553-11.467 10.452"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.51 92.621-0.20295-27.398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.83 76.138 10.553-11.67 10.452 11.467"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillet);
export default __webpack_public_path__ + "static/media/fillet.80878adf6e3637f1d07856ef1ae84b0a.svg";
export { ForwardRef as ReactComponent };